import React from 'react';

const WarningCheckBox = (props) => {
    return (<div className={"warning-checkbox-form" + (props.value ? " checked" : "")}>
        <div>
            <input id={props.name} name={props.name} checked={props.value} className="form-control" onChange={props.onChange} type="checkbox" disabled={props.disabled ? "disabled" : ""} />
            <label htmlFor={props.name}></label>
        </div>
        <div className="warning-checkbox-text">
            {props.warningText}
        </div>
    </div>);
}
export default WarningCheckBox;